export default function oversToBalls(overs, ballsPerOver) {
  if (!overs || !ballsPerOver) return 0;

  const [o, b] = (overs + "").split(".");
  return (o || 0) * ballsPerOver + (b || 0);
}
